import { z } from 'zod';

export const searchSchema = z.object({
  ngay_ct1: z.string(),
  ngay_ct2: z.string(),
  detail_by: z.number().optional().nullable(),
  group_by: z.coerce.string().nullable(),
  loai_hang_yn: z.boolean(),

  ma_nv: z.string().optional().nullable(),
  ma_kh: z.string().optional().nullable(),
  nh_kh1: z.string().optional().nullable(),
  nh_kh2: z.string().optional().nullable(),
  nh_kh3: z.string().optional().nullable(),
  rg_code: z.string().optional().nullable(),
  ma_vt: z.string().optional().nullable(),
  ma_lvt: z.string().optional().nullable(),
  ton_kho_yn: z.boolean().nullable(),
  nh_vt1: z.string().optional().nullable(),
  nh_vt2: z.string().optional().nullable(),
  nh_vt3: z.string().optional().nullable(),
  ma_kho: z.string().optional().nullable(),
  ma_unit: z.string().optional().nullable(),
  mau_bc: z.number().nullable(),

  ma_gd: z.string().optional().nullable(),
  tk_vt: z.string().optional().nullable(),
  tk_dt: z.string().optional().nullable(),
  tk_gv: z.string().optional().nullable(),
  ma_lo: z.string().optional().nullable(),
  ma_vi_tri: z.string().optional().nullable(),
  dien_giai: z.string().optional().nullable(),
  report_filtering: z.string().optional().nullable(),
  data_analysis_struct: z.string().optional().nullable()
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export const initialValues: SearchFormValues = {
  ngay_ct1: '',
  ngay_ct2: '',
  detail_by: 200,
  group_by: '0',
  loai_hang_yn: true,
  ma_nv: null,
  ma_kh: '',
  nh_kh1: '',
  nh_kh2: '',
  nh_kh3: '',
  rg_code: '',
  ma_vt: '',
  ton_kho_yn: true,
  nh_vt1: '',
  nh_vt2: '',
  nh_vt3: '',
  ma_kho: '',
  ma_unit: '',
  mau_bc: 20,

  ma_gd: '',
  tk_vt: '',
  tk_dt: '',
  tk_gv: '',
  ma_lo: '',
  ma_vi_tri: '',
  dien_giai: '',
  report_filtering: '0',
  data_analysis_struct: '0'
};
